/* eslint-disable */

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import 'dayjs/locale/th';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import { Card, Button, Space, Typography, Form, InputNumber, message, Spin } from 'antd';
import { CalculatorOutlined, ReloadOutlined, SaveOutlined } from '@ant-design/icons';

dayjs.extend(buddhistEra);
dayjs.locale('th');

const { Title, Text } = Typography;

function RefferenceFactor(props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api_read_factor();
  }, []);

  /**
   * Fetch current factor values from API
   */
  async function api_read_factor() {
    setLoading(true);

    const formData = new FormData();
    axios
      .post(props.app_hostname + '/api/order/factor/read', formData, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + props.permitdata.token,
        },
      })
      .then((response) => {
        setLoading(false);
        if (response.data.status === 'OK') {
          form.setFieldsValue({
            creditcard_charge_100: response.data.factor.creditcard_charge_100,
            delivery_charge_100: response.data.factor.delivery_charge_100,
            service_margin_100: response.data.factor.service_margin_100,
          });
        } else {
          message.error(response.data.message || 'เกิดข้อผิดพลาดในการโหลดข้อมูล');
        }
      })
      .catch((err) => {
        setLoading(false);
        message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
      });
  }

  /**
   * Save updated factor parameters to API
   */
  async function handleSubmit(values) {
    setSaving(true);

    const formData = new FormData();
    formData.append('creditcard_charge', values.creditcard_charge_100);
    formData.append('delivery_charge', values.delivery_charge_100);
    formData.append('service_margin', values.service_margin_100);

    axios
      .post(props.app_hostname + '/api/order/factor/edit', formData, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + props.permitdata.token,
        },
      })
      .then((response) => {
        setSaving(false);
        if (response.data.status === 'OK') {
          message.success('บันทึก Factor สำเร็จ');
        } else {
          message.error(response.data.message || 'เกิดข้อผิดพลาด');
        }
      })
      .catch((err) => {
        setSaving(false);
        message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
      });
  }

  return (
    <div className='page-wrapper'>
      <div className='page-card'>
        <Space direction='vertical' size='large' style={{ width: '100%' }}>
          <div className='page-header-actions'>
            <div>
              <Title level={3} style={{ margin: 0 }}>
                <CalculatorOutlined style={{ color: '#fa8c16', marginRight: '8px' }} />
                ค่าปัจจัยและค่าธรรมเนียม (Factor)
              </Title>
              <Text type='secondary'>ตั้งค่าเปอร์เซ็นต์ค่าธรรมเนียมและค่าบริการทางการค้า</Text>
            </div>
            <Button icon={<ReloadOutlined />} onClick={api_read_factor} loading={loading}>
              รีเฟรช
            </Button>
          </div>

          <Spin spinning={loading}>
            <Card title='สัดส่วนค่าบริการทางการค้า' size='default'>
              <Form form={form} layout='vertical' onFinish={handleSubmit} style={{ maxWidth: 600 }}>
                <Form.Item
                  name='creditcard_charge_100'
                  label='ค่าธรรมเนียมบัตรเครดิต (%)'
                  rules={[{ required: true, message: 'กรุณากรอกค่าธรรมเนียมบัตรเครดิต' }]}
                >
                  <InputNumber
                    min={0.001}
                    max={100}
                    step={0.001}
                    precision={3}
                    style={{ width: '100%' }}
                    placeholder='0.000'
                  />
                </Form.Item>

                <Form.Item
                  name='delivery_charge_100'
                  label='ค่าธรรมเนียมจัดส่งสินค้า (%)'
                  rules={[{ required: true, message: 'กรุณากรอกค่าธรรมเนียมจัดส่งสินค้า' }]}
                >
                  <InputNumber
                    min={0.001}
                    max={100}
                    step={0.001}
                    precision={3}
                    style={{ width: '100%' }}
                    placeholder='0.000'
                  />
                </Form.Item>

                <Form.Item
                  name='service_margin_100'
                  label='ค่าธรรมเนียมบริการ (%)'
                  rules={[{ required: true, message: 'กรุณากรอกค่าธรรมเนียมบริการ' }]}
                >
                  <InputNumber
                    min={0.001}
                    max={100}
                    step={0.001}
                    precision={3}
                    style={{ width: '100%' }}
                    placeholder='0.000'
                  />
                </Form.Item>

                <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '24px' }}>
                  <Button
                    type='primary'
                    htmlType='submit'
                    icon={<SaveOutlined />}
                    loading={saving}
                    size='large'
                  >
                    บันทึก
                  </Button>
                </div>
              </Form>
            </Card>
          </Spin>
        </Space>
      </div>
    </div>
  );
}

export default RefferenceFactor;
